import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

export default function PrivateRoute() {
    const AUTH = useSelector((state) => state.auth);

    const auth = AUTH.isAuth;

    return auth ? <Outlet /> : <Navigate to="/" />;
}
